import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import {
  Table,
  TableBody,
  TableHead,
  TableContainer,
  TableRow,
  Paper,
  Typography,
  Link,
  Tooltip,
  Stack,
  TextField,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Grid,
  Card,
  CardActions,
  CardContent,
  Modal,
  IconButton,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { getProjectList, deleteProject, downloadVimeoVideo, updateProjectDetails } from '../../apis/apiList/projectApi';
import CancelIcon from '@mui/icons-material/Cancel';
import Pagination from '@mui/material/Pagination';
import PaginationItem from "@mui/material/PaginationItem";
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { useMessage } from "../../context/MessageContext";
import { useApp } from "../../context/AppContext";
import { AddProject } from './AddProject';
import AddMultipleProject from './AddMultipleProject';
import { downloadFileFromBox } from '../../apis/apiList/boxAssetsApi';
import CloseIcon from '@mui/icons-material/Close';
import EditProjectModal from '../projects/EditProjectModal';
import EditIcon from '@mui/icons-material/Edit';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#495967',
        color: theme.palette.common.white,
        fontWeight: 600
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const CustomPaginationItem = styled(PaginationItem)(({ theme, selected }) => ({
    backgroundColor: selected ? theme.palette.primary.main : "#495967", // Red for active, dark blue for others
    color: "#fff",
    borderRadius: "0px", // Square but slightly rounded edges
    fontWeight: selected ? "bold" : "normal",
    margin: "0 4px",
    maxHeight: '26px',
    padding: '0px',
    "&:hover": {
      backgroundColor: selected ? "#d40000" : "#1e2a33",
    },
    "&.Mui-selected":{
        backgroundColor: selected ? theme.palette.primary.main : "#495967", // Red for active, dark blue for others
        color: "#fff",
        padding: '0px'
    }
  }));


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 700,
  bgcolor: 'background.paper',
  borderRadius: 6,
  boxShadow: 24,
  p: 4,
};

function ProjectList({ orgId, organization }) {
    // console.log('in project list organization', organization);
    const navigate = useNavigate();
    const [originalProjectList, setOriginalProjectList] = useState([]);
    const [projectList, setProjectList] = useState([]);
    const [paginatedProjectList, setPaginatedProjectList] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [showDescription, setShowDescription] = useState(null);
    const [showVideoIframe, setShowVideoIframe] = useState(null);
    const [showEmbededIframe, setShowEmbededIframe] = useState(null);
    const [downloadInProgress, setDownloadInProgress] = useState(null);
    const [open, setOpen] = useState(false);
    const [selectedDeleteProject, setSelectedDeleteProject] = useState({});
    const { showMessage } = useMessage();
    const { userDetails } = useApp();
    const [showCreateProject, setShowCreateProject] = useState(false);
    const [openDownloadModal, setOpenDownloadModal] = useState(false);
    const [selectVideoDownload, setSelectVideoDownload] = useState({});

    const [openEditModal, setOpenEditModal] = useState(false);
    const [selectedEditProject, setSelectedEditProject] = useState(null);
    const [statusFilter, setStatusFilter] = useState("all");

    const handleVideoDownloadModal = (project) => {
      setSelectVideoDownload(project);
      setOpenDownloadModal(true)
    };
    const handleVideoDownloadModalClose = () => {
      setOpenDownloadModal(false);
      setSelectVideoDownload({});
    };

    const handleDeleteDialog = (project) => {
        setSelectedDeleteProject(project);
        setOpen(true);
    };

    const handleClose = () =>{ 
        setSelectedDeleteProject({})
        setOpen(false)
    }

    useEffect(() => {
        async function fetchProjectList() {
            try {
                let projects = await getProjectList({ id: orgId, userId: userDetails._id });
                if(projects?.data.length > 0){
                    const filteredRows = searchQuery
                        ? projects?.data.filter((project) =>
                            project.projectName.toLowerCase().includes(searchQuery.toLowerCase())
                        )
                        : projects?.data;

                        setProjectList(filteredRows);
                        handlePagination(filteredRows, page);
                }

                setOriginalProjectList(projects.data);
            } catch (err) {
                console.log(err);
            }
        }
        fetchProjectList();
    }, [])

    const handleSearchChange = (event) => {
        const str = event.target.value.trim()
        setSearchQuery(str);

        const filteredRows = originalProjectList.filter((project) =>
            project.projectName.toLowerCase().includes(str.toLowerCase())
        );
        setProjectList(filteredRows);
        handlePagination(filteredRows, 1);
        setPage(1);
    }

    const handleChange = (event, value) => {
        setPage(value);
        handlePagination(projectList, value);
    };

    const handlePagination = (projectList, pageNum) => {
        const startIndex = (pageNum - 1) * rowsPerPage;
        const endIndex = startIndex + rowsPerPage;
        const pageList = projectList.slice(startIndex, endIndex);
        setPaginatedProjectList(pageList);
    };

    const handleScriptDownload = async (project, index) => {
      if(project?.approvedScriptFileId){
        try {
          const file = await downloadFileFromBox(project.approvedScriptFileId);
          console.log('file', file)
          if (file?.data) {
            // Step 2: Create a temporary <a> tag to trigger download
            const link = document.createElement('a');
            link.href = file?.data;
            link.download = ''; // Optional: specify filename
            link.target = '_blank'; // optional, for opening in new tab
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            console.error('File URL not found');
          }
        } catch (error) {
          console.log('error', error)
        }
      } else {
        showMessage('Script not found', 'error')
      }
        // setSelectedIndex(index);
        // setShowDescription(project.description)
        // setDownloadInProgress('');
        // setShowEmbededIframe('')
        // setShowVideoIframe('');
    }

    const handleVideoDownload =async (videoId, index) => {
      
      if(videoId){
        try {
          const responseFile = await downloadVimeoVideo(videoId);
          // const file = await downloadVimeoVideo(selectVideoDownload._id);
          console.log('responseFile', responseFile)
          if (responseFile?.data) {
            const link = document.createElement('a');
            link.href = responseFile?.data;
            const pathname = new URL(responseFile?.data).pathname;
            const parts = pathname.split('/');
            let vimeoFileName = parts[parts.length - 1];
            link.download = vimeoFileName || `video_${Date.now()}.mp4`;
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            handleVideoDownloadModalClose()
          } else {
            console.error('File URL not found');
          }
        } catch (error) {
          console.log('error', error)
        }
      } else {
        showMessage('Video not found', 'error')
      }
        // setSelectedIndex(index);
        // const url = getIframeUrl(project);
        // setShowVideoIframe(url);
        // setShowDescription('')
        // setDownloadInProgress('');
        // setShowEmbededIframe('')
    }

    const handleEmbededIframe = (project, index) => {
        setSelectedIndex(index);
        if(project?.vimeoVideoId){
          let url= 'https://player.vimeo.com/video/'+project?.vimeoVideoId;
          setShowEmbededIframe('<iframe width="560" height="315" src='+url+' frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
        } else {
          setShowEmbededIframe('');
        }
        setShowDescription('')
        setDownloadInProgress('');
        setShowVideoIframe('');
    }
    const handleVODownload = async (project, index) => {
      if(project?.approvedVoiceOverFileId){
        try {
          const file = await downloadFileFromBox(project.approvedVoiceOverFileId);
          console.log('file', file)
          if (file?.data) {
            const link = document.createElement('a');
            link.href = file?.data;
            link.download = '';
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            console.error('File URL not found');
          }
        } catch (error) {
          console.log('error', error)
        }
      } else {
        showMessage('Voice over not found', 'error')
      }
        // setSelectedIndex(index);
        // setShowDescription('')
        // setDownloadInProgress('Download: In progress');
        // setShowEmbededIframe('')
        // setShowVideoIframe('');
    }
    const getIframeUrl = (project) => {
        let url;
        if(project?.vimeoVideoId){
            url= 'https://player.vimeo.com/video/'+project?.vimeoVideoId;
        } else {
          url = ''
        }
        return url
    }

    const handleDelete = async () => {
        console.log('selected delete project', selectedDeleteProject);
        try {
          const response = await deleteProject(selectedDeleteProject._id);
          console.log('response', response);
          if(response.success) {
            handleDeleteFilter(selectedDeleteProject._id)
            showMessage(response.message, 'success')
            setSelectedDeleteProject({});
            handleClose()
          }
        } catch (err) {
          console.log('err', err)
          if (err?.response) {
            showMessage(err?.response?.data?.message, "error");
          } else {
            showMessage(err?.message, "error");
          }
        }
    
        handleClose();
    };

    const handleDeleteFilter = () => {
        console.log('projectList before delete', projectList)
        const newList = projectList.filter((project)=> project._id !== selectedDeleteProject._id);
        console.log('newList after delete', newList)
        setProjectList(newList);
        handlePagination(newList, page);
        // setPaginatedProjectList(newList);
    }

    const handleAddProjectShow = ()=>{
      setShowCreateProject(!showCreateProject)
    }

    const handleRoleBasedNavigate = (projectId, project) =>{
      console.log('project details before redirecting', project);
      
      if(userDetails && userDetails.role == 'admin'){
        if(userDetails && userDetails.role == 'admin'){
          navigate(
            `/org/${orgId}/project/view/${projectId}`
          );
        } else if ( userDetails && userDetails.role == 'subscriber'){
          navigate(
            `/subs/org/${orgId}/project/view/${projectId}`
          );
        }
      } else {

        if(project.status == 'Not Started'){
          showMessage('Project is not started yet', 'error');
          return;
        }
        let projectStatus = project?.status?.toLowerCase();
        console.log('projectStatus', projectStatus);
        
        // if((projectStatus == 'active' || projectStatus == 'pending approval' || projectStatus == 'approved' || projectStatus == 'completed') && project?.associatedUsers && project?.associatedUsers.includes(userDetails._id)){
        if((projectStatus == 'active' || projectStatus == 'pending approval' || projectStatus == 'approved' || projectStatus == 'completed' || projectStatus == 'inactive')){
          if(userDetails && userDetails.role == 'admin'){
            navigate(
              `/org/${orgId}/project/view/${projectId}`
            );
          } else if ( userDetails && userDetails.role == 'subscriber'){
            navigate(
              `/subs/org/${orgId}/project/view/${projectId}`
            );
          }
        } else {
          showMessage('You don\'t have permission to access this project', 'error');
          return;
        }
      }
    }

    // const approvalStages = ['scriptsAndVisuals', 'voiceOver', 'video'];
    const stageLabels = {
      scriptsAndVisuals: 'Scripts & Visuals',
      voiceOver: 'Voice Over',
      video: 'Video',
    };

    function getLatestApprovalStage(approvals) {

      if (!approvals) return "No approval data";

      const stages = Object.keys(stageLabels);

      const allApproved = stages.every((stage) => approvals[stage]);
      if (allApproved) {
        // return "All stages approved";
        return "Approved";
      }

      for (let i = 0; i < stages.length; i++) {
        const stage = stages[i];
        if (!approvals[stage]) {
          return stageLabels[stage];
        }
      }

      return "No stage in progress";
    }

    const handleListChange = (projects) => {
      console.log("projects", projects);
      console.log("originalProjectList", originalProjectList);
      let overAllProject = [...projects, ...originalProjectList];
      console.log("overAllProject", overAllProject);
      if (overAllProject.length > 0) {
        const filteredRows = searchQuery
          ? overAllProject.filter((project) =>
              project.projectName
                .toLowerCase()
                .includes(searchQuery.toLowerCase())
            )
          : overAllProject;

        console.log("filteredRows", filteredRows);
        console.log("page", page);
        setProjectList(filteredRows);
        handlePagination(filteredRows, page);
      }

      // setOriginalProjectList(projects.data);
    }

    const handleUpdate = async (updatedData) => {
      const updatedProjectList = projectList.map((project) => {
        if (project._id == updatedData?._id) {
          return updatedData;
        }
        return project;
      });
      setProjectList(updatedProjectList);
      handlePagination(updatedProjectList, page);
    };

    const handleStatusChange = (event) => {
      const value = event.target.value;
      let filtered = originalProjectList;
      setStatusFilter(value);
      // status filter
      if (value && value !== "all") {
        filtered = filtered.filter(
          (project) => project.status.toLowerCase() === value.toLowerCase()
        );
      }

      setProjectList(filtered);
      handlePagination(filtered, 1);
      setPage(1);
    };
    return (
      <>
        {!showCreateProject && (
          <>
            {/* {projectList && projectList.length > 0 && ( */}
            <div>
              <Stack
                direction={{ xs: "column", md: "row" }}
                justifyContent={"space-between"}
              >
                <Box sx={{ display: { xs: "block", md: "flex"}, gap: 2, alignItems: "baseline", mb:{ xs: 2, md: 0} }}>
                  <div className="project-search-div">
                    <input
                      type="text"
                      className="project-search"
                      placeholder="Search"
                      onChange={handleSearchChange}
                    />
                  </div>
                  {/* Dropdown Filter */}
                  <FormControl size="small" sx={{ minWidth: 220 }}>
                    <InputLabel>Status</InputLabel>
                    <Select value={statusFilter} onChange={handleStatusChange} label="Status" sx={{
                      "& .MuiSelect-select": {
                        padding: "10px 14px !important", // custom padding
                      },
                    }}>
                      <MenuItem value="all">All</MenuItem>
                      <MenuItem value="active">Active</MenuItem>
                      <MenuItem value="inactive">Inactive</MenuItem>
                      <MenuItem value="completed">Completed</MenuItem>
                      <MenuItem value="pending approval">Pending Approval</MenuItem>
                      <MenuItem value="not started">Not Started</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
                {userDetails && userDetails.role == "admin" && (
                  <Box sx={{ mb: { xs: 2, md: 0 } }}>
                    <Button variant="contained" onClick={handleAddProjectShow}>
                      + ADD SNAPSHOTS
                    </Button>
                  </Box>
                )}
              </Stack>
              <TableContainer component={Paper} sx={{ mb: "20px" }}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Project Name</StyledTableCell>
                      <StyledTableCell align="left">Actions</StyledTableCell>
                      <StyledTableCell align="left">Due date</StyledTableCell>
                      <StyledTableCell align="left">
                        Current Stage
                      </StyledTableCell>
                      <StyledTableCell align={ (userDetails.role == "admin" && (userDetails.jobTitle == 'Actor' || userDetails.jobTitle == 'Production Manager' || userDetails.jobTitle.toLowerCase() == 'admin')) ? "right" : "center"}>Status</StyledTableCell>
                      {userDetails && (userDetails.role == "admin" && (userDetails.jobTitle == 'Actor' || userDetails.jobTitle == 'Production Manager' || userDetails.jobTitle.toLowerCase() == 'admin')) && <StyledTableCell align="right">Action</StyledTableCell>}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {projectList && projectList.length > 0 ? (
                      paginatedProjectList.map((project, index) => (
                        <>
                          <StyledTableRow
                            key={index}
                            sx={{ backgroundColor: "rgba(0,0,0,.05)" }}
                          >
                            <StyledTableCell
                              component="th"
                              scope="row"
                              align="left"
                              sx={{
                                cursor: "pointer",
                                width: "15%",
                                minWidth: "150px",
                              }}
                              onClick={() => {
                                handleRoleBasedNavigate(project._id, project);
                              }}
                            >
                              {project.projectName}
                            </StyledTableCell>
                            <StyledTableCell
                              align="left"
                              sx={{ width: "10%", minWidth: "150px" }}
                            >
                              <Stack direction={"row"} gap={1}>
                                <Tooltip
                                  title="Script pdf"
                                  arrow
                                  onClick={() => {
                                    handleScriptDownload(project, index);
                                  }}
                                >
                                  <img
                                    src="/images/des.png"
                                    alt="script"
                                    style={{
                                      width: "20px",
                                      height: "18px",
                                      margin: "1px",
                                    }}
                                  />
                                </Tooltip>
                                <Tooltip
                                  title="Video download"
                                  onClick={() => {
                                    // handleVideoDownload(project, index);
                                    handleVideoDownloadModal(project);
                                  }}
                                  arrow
                                >
                                  <img
                                    src="/images/video.png"
                                    alt="video image"
                                    style={{
                                      width: "20px",
                                      height: "18px",
                                      margin: "1px",
                                    }}
                                  />
                                </Tooltip>
                                <Tooltip
                                  title="Voice Over Download"
                                  onClick={() => {
                                    handleVODownload(project, index);
                                  }}
                                  arrow
                                >
                                  <img
                                    src="/images/down.png"
                                    alt="download image"
                                    style={{
                                      width: "20px",
                                      height: "18px",
                                      margin: "1px",
                                    }}
                                  />
                                </Tooltip>
                                <Tooltip
                                  title="Embeded iframe"
                                  onClick={() => {
                                    handleEmbededIframe(project, index);
                                  }}
                                  arrow
                                >
                                  <img
                                    src="/images/embeded.png"
                                    alt="embeded image"
                                    style={{
                                      width: "20px",
                                      height: "18px",
                                      margin: "1px",
                                    }}
                                  />
                                </Tooltip>
                              </Stack>
                            </StyledTableCell>
                            <StyledTableCell
                              align="left"
                              sx={{ width: "15%", minWidth: "150px" }}
                            >
                              {project.dueDate == null ? "TBD" : moment(project.dueDate).format("MM/DD/YYYY")}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {getLatestApprovalStage(project.approvals)}
                            </StyledTableCell>
                            <StyledTableCell align={ (userDetails.role == "admin" && (userDetails.jobTitle == 'Actor' || userDetails.jobTitle == 'Production Manager' || userDetails.jobTitle.toLowerCase() == 'admin')) ? "right" : "center"}>
                              {project.status}
                            </StyledTableCell>
                            {userDetails && (userDetails.role == "admin" && (userDetails.jobTitle == 'Actor' || userDetails.jobTitle == 'Production Manager' || userDetails.jobTitle.toLowerCase() == 'admin')) && <StyledTableCell align="right">
                              <Box sx={{display: 'flex', gap: 2, justifyContent: 'end'}}>
                                <EditIcon
                                  style={{ color: "#D10000", cursor: "pointer" }}
                                  onClick={() => {
                                    setSelectedEditProject(project);
                                    setOpenEditModal(true);
                                  }}
                                />
                                <CancelIcon
                                  style={{ color: "#D10000", cursor: "pointer" }}
                                  onClick={() => {
                                    handleDeleteDialog(project);
                                  }}
                                />
                              </Box>
                            </StyledTableCell>}
                          </StyledTableRow>
                          {index == selectedIndex ? (
                            <Box sx={{ width: "100%" }}>
                              {showDescription && (
                                <Typography padding={"16px"} component={"p"}>
                                  {" "}
                                  Description: {showDescription}
                                </Typography>
                              )}
                              {showVideoIframe && (
                                <iframe
                                  src={showVideoIframe}
                                  width="640"
                                  height="400"
                                  frameborder="0"
                                  allow="autoplay; fullscreen"
                                  allowfullscreen
                                ></iframe>
                              )}
                              {showEmbededIframe ? (
                                <Typography
                                  component={"p"}
                                  sx={{ width: "330%" }}
                                >
                                  {showEmbededIframe}
                                </Typography>
                              ) : (
                                <Typography
                                  component={"p"}
                                  sx={{ width: "330%" }}
                                >
                                  This video is currently unavailable. Please
                                  check back later.
                                </Typography>
                              )}
                              {downloadInProgress && (
                                <Typography>{downloadInProgress}</Typography>
                              )}
                            </Box>
                          ) : (
                            <></>
                          )}
                        </>
                      ))
                    ) : (
                      <StyledTableRow
                        sx={{ backgroundColor: "rgba(0,0,0,.05)" }}
                      >
                        <StyledTableCell align="left">
                          <Box> No Project found</Box>
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* <Pagination count={10} showFirstButton showLastButton /> */}
              <Pagination
                count={Math.ceil(projectList.length / rowsPerPage)}
                page={page}
                onChange={handleChange}
                renderItem={(item) => <CustomPaginationItem {...item} />}
                siblingCount={1}
                boundaryCount={1}
                showFirstButton
                showLastButton
              />
            </div>
            {/* )} */}
            {/* Dialog for delete organization */}
            <Dialog open={open} onClose={handleClose}>
              <DialogTitle>
                Are you sure you want to delete project
                <strong>{`" ${selectedDeleteProject.projectName} "`}</strong>?
              </DialogTitle>
              <DialogActions>
                <Button onClick={handleClose} color="primary">
                  Cancel
                </Button>
                <Button onClick={handleDelete} color="error">
                  Delete
                </Button>
              </DialogActions>
            </Dialog>

            {/* video download modal */}
            <Modal
              open={openDownloadModal}
              onClose={handleVideoDownloadModalClose}
            >
              <Box sx={style}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography
                    variant="h5"
                    fontWeight={600}
                    sx={{ mb: 3, textAlign: "center" }}
                  >
                    Video to Download
                  </Typography>
                  <IconButton onClick={handleVideoDownloadModalClose}>
                    <CloseIcon />
                  </IconButton>
                </Box>

                <Grid container spacing={3}>
                  {/* Horizontal Video */}
                  <Grid item xs={12} sm={6}>
                    <Card
                      sx={{
                        borderRadius: 4,
                        boxShadow: 3,
                        transition: "0.3s",
                        "&:hover": { boxShadow: 6 },
                      }}
                    >
                      <Box
                        sx={{
                          height: 200,
                          overflow: "hidden",
                          borderTopLeftRadius: 16,
                          borderTopRightRadius: 16,
                        }}
                      >
                        <iframe
                          src={`https://player.vimeo.com/video/${selectVideoDownload.vimeoVideoId}`}
                          width="100%"
                          height="200"
                          allow="autoplay; fullscreen; picture-in-picture"
                          allowFullScreen
                          title="Horizontal Vimeo Video"
                          style={{
                            borderTopLeftRadius: 16,
                            borderTopRightRadius: 16,
                          }}
                        ></iframe>
                      </Box>
                      <CardContent>
                        <Typography
                          variant="subtitle1"
                          fontWeight={500}
                          gutterBottom
                        >
                          Horizontal Video
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Best for wide-screen or desktop viewing.
                        </Typography>
                      </CardContent>
                      <CardActions
                        sx={{ justifyContent: "center", pb: 2, px: 2 }}
                      >
                        <Button
                          variant="contained"
                          fullWidth
                          color="secondary"
                          onClick={() =>
                            handleVideoDownload(
                              selectVideoDownload.vimeoVideoId
                            )
                          }
                          sx={{ borderRadius: 3, py: 1 }}
                        >
                          📥 Download Horizontal
                        </Button>
                      </CardActions>
                    </Card>
                  </Grid>

                  {/* Vertical Video */}
                  <Grid item xs={12} sm={6}>
                    <Card
                      sx={{
                        borderRadius: 4,
                        boxShadow: 3,
                        transition: "0.3s",
                        "&:hover": { boxShadow: 6 },
                      }}
                    >
                      <Box
                        sx={{
                          height: 200,
                          overflow: "hidden",
                          borderTopLeftRadius: 16,
                          borderTopRightRadius: 16,
                        }}
                      >
                        <iframe
                          src={`https://player.vimeo.com/video/${selectVideoDownload.vimeoVerticalVideoId}`}
                          width="100%"
                          height="200"
                          frameBorder="0"
                          allow="autoplay; fullscreen; picture-in-picture"
                          allowFullScreen
                          title="Vertical Vimeo Video"
                          style={{
                            borderTopLeftRadius: 16,
                            borderTopRightRadius: 16,
                          }}
                        ></iframe>
                      </Box>
                      <CardContent>
                        <Typography
                          variant="subtitle1"
                          fontWeight={500}
                          gutterBottom
                        >
                          Vertical Video
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Ideal for mobile and portrait orientation screens.
                        </Typography>
                      </CardContent>
                      <CardActions
                        sx={{ justifyContent: "center", pb: 2, px: 2 }}
                      >
                        <Button
                          variant="contained"
                          fullWidth
                          color="secondary"
                          onClick={() =>
                            handleVideoDownload(
                              selectVideoDownload.vimeoVerticalVideoId
                            )
                          }
                          sx={{ borderRadius: 3, py: 1 }}
                        >
                          📥 Download Vertical
                        </Button>
                      </CardActions>
                    </Card>
                  </Grid>
                </Grid>
              </Box>
            </Modal>
          </>
        )}

        {showCreateProject && (
          <>
            <AddMultipleProject
              handleAddProjectShow={handleAddProjectShow}
              organization={organization}
              handleProjectListChange={handleListChange}
            />
            {/* <AddProject
              handleAddProjectShow={handleAddProjectShow}
              organization={organization}
            /> */}
          </>
        )}

        {selectedEditProject && <EditProjectModal 
          open={openEditModal}
          onClose={() => setOpenEditModal(false)}
          onSubmit={handleUpdate}
          projectData={selectedEditProject}
          userDetails={userDetails}
        />}
      </>
    );
}

export default ProjectList